console.log('[INDEX] Starting app initialization...');
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import WrapperApp from "./WrapperApp";
import ErrorBoundary from "./components/ErrorBoundary";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { API_CONFIG } from './config/appConfig';

// Cognito configuration read from environment variables by tenantConfig.js
// No Amplify.configure() needed - using native AWS SDK
console.log('Cognito Configuration:', {
  userPoolId: import.meta.env.VITE_AWS_USER_POOLS_ID,
  clientId: import.meta.env.VITE_AWS_USER_POOLS_WEB_CLIENT_ID,
  region: import.meta.env.VITE_AWS_COGNITO_REGION || 'eu-west-2'
});

// Create React Query client with optimized cache settings
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: API_CONFIG.CACHE.STALE_TIME,
      cacheTime: API_CONFIG.CACHE.CACHE_TIME,
      refetchOnWindowFocus: false, // Don't refetch on window focus
      refetchOnMount: false, // Don't refetch on component mount if data exists
      refetchOnReconnect: false, // Don't refetch on network reconnect
      retry: 1, // Only retry once on failure
      structuralSharing: true, // Deduplicate requests
    },
  },
});

console.log('[INDEX] Creating React root...');
const root = ReactDOM.createRoot(document.getElementById("root"));
console.log('[INDEX] Rendering app...');
root.render(
  <ErrorBoundary fallbackMessage="The app encountered an unexpected error. Please refresh to continue.">
    <QueryClientProvider client={queryClient}>
      <WrapperApp />
    </QueryClientProvider>
  </ErrorBoundary>
);
console.log('[INDEX] App render complete');

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
